import React from 'react';
import PropTypes from 'prop-types';
function FilterItem(_ref) {
  var _ref$filterTitle = _ref.filterTitle,
    filterTitle = _ref$filterTitle === void 0 ? 'title' : _ref$filterTitle,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "ais-Panel"
  }, filterTitle && /*#__PURE__*/React.createElement("div", {
    className: "ais-Panel-header"
  }, filterTitle), /*#__PURE__*/React.createElement("div", {
    className: "ais-Panel-body"
  }, children));
}
FilterItem.propTypes = {
  children: PropTypes.node.isRequired,
  filterTitle: PropTypes.string
};
export default FilterItem;